module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAR0lEQVQYV2Oc7OamyMzKupCBkdGc4f//k39//45nnObtfYiBkdGWAQb+/z/MOM3H5wcDAwM7XJCB4Sd2lTAzGRkZzf9DzQQA3D8eiIISDxEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/dian.png
// module id = ZEdv
// module chunks = 1